<ion-button class="ion-no-padding sort">
	<ion-icon slot="start" class="icon-Sort"></ion-icon>
</ion-button>
<ng-container *ngIf="isNotDefaultSort$ | async">
	<ion-item class="bubble"></ion-item>
</ng-container>
